var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.label,"disabled":_vm.isDisabled},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }